import { Box, Typography, useTheme } from "@mui/material";
import CommentBulb from "./comment-bulb";
import {
  commentBulbBackgroundMap,
  commentBulbColorMap,
} from "@/modules/lead-page/new/constants";
import {
  ConversationSummaryInfoProps,
  ConversationSummaryContent,
} from "@/modules/lead-page/types";
import ExpandableItemsList from "./expandable-items-list";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

const ConversationSummaryInfo = ({ item }: ConversationSummaryInfoProps) => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();
  let parsedContent: ConversationSummaryContent | null;
  try {
    parsedContent = item.content ? JSON.parse(item.content) : null;

    if (!parsedContent) {
      return null;
    }
  } catch (error) {
    return null;
  }

  return (
    <>
      {parsedContent.title && (
        <Box
          sx={{
            display: "flex",
            gap: theme.nawy.spacing.xxs,
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <Typography
            sx={{
              color: theme.nawy.colors.semantic.text.primary,
              ...theme.nawy.typography.english.variants.body.sm.semibold,
              minWidth: "84px",
            }}
          >
            Details
          </Typography>
          <Typography
            sx={{
              color: theme.nawy.colors.semantic.text.primary,
              ...theme.nawy.typography.english.variants.body.sm.regular,
            }}
          >
            {parsedContent.title}
          </Typography>
        </Box>
      )}
      {parsedContent.properties && parsedContent.properties.length > 0 && (
        <Box
          sx={{
            display: isMobile ? "block" : "flex",
            gap: theme.nawy.spacing.xxs,
          }}
        >
          <Typography
            sx={{
              color: theme.nawy.colors.semantic.text.primary,
              ...theme.nawy.typography.english.variants.body.sm.semibold,
              minWidth: "84px",
            }}
          >
            Property links
          </Typography>
          <ExpandableItemsList items={parsedContent.properties} />
        </Box>
      )}

      {parsedContent.summary && (
        <Box sx={{ marginTop: theme.nawy.spacing.xs }}>
          <CommentBulb
            content={parsedContent.summary}
            backgroundColor={commentBulbBackgroundMap.get("default")}
            color={commentBulbColorMap.get("default")}
            mentions={item.mentions}
          />
        </Box>
      )}
    </>
  );
};

export default ConversationSummaryInfo;
